import {
  Directive,
  ElementRef,
  inject,
  Input,
  OnChanges,
} from '@angular/core';

@Directive({
  selector: '[issDisabled]',
  standalone: true,
})
export class DisabledDirective implements OnChanges {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input('issDisabled') public disabled?: boolean | null;

  public ngOnChanges(): void {
    const { nativeElement } = this.elementRef;
    return this.disabled
      ? nativeElement.setAttribute('disabled', 'true')
      : nativeElement.removeAttribute('disabled');
  }
}
